import { toast } from "react-toastify";

export const handleError = ({ error, showToast = true }) => {
    const errorResponse = error.response && error.response.data
        ? error.response.data.message
        : error.message;

    const errorMessage = errorResponse ? errorResponse : error;

    if (showToast)
        toast.error(errorMessage);

    return errorMessage;
};
